import axios from 'axios'

import { getApiAccessToken } from '../auth/getApiAccessToken'
import { apiConfig, msalInstance } from '../authConfig'

const apiClient = axios.create({
  baseURL: apiConfig.webApiUri,
  headers: {
    'Content-Type': 'application/json',
  },
})

msalInstance.initialize().then(() => {
  apiClient.interceptors.request.use(async (config) => {
    const token = await getApiAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token.accessToken}`
    }
    return config
  })
})

export default apiClient
